'use client';

import classNames from 'classnames';
/* eslint-disable jsx-a11y/click-events-have-key-events */
import type React from 'react';
import { useState } from 'react';

type Props = {
  icon?: string;
  panel?: React.ReactNode;
  header?: React.ReactNode;
  panelclass?: string;
  headerclass?: string;
};

export const AccordionItem = ({
  headerclass,
  panelclass,
  header,
  panel,
  icon,
}: Props) => {
  const [expanded, setExpanded] = useState(false);

  function handleClick() {
    setExpanded(() => !expanded);
  }

  return (
    <>
      <div
        role="button"
        tabIndex={0}
        onClick={handleClick}
        className={`${headerclass || ''} ui-cursor-pointer`}
      >
        {header}
        {icon && <div dangerouslySetInnerHTML={{ __html: icon }} />}
      </div>

      <div
        className={classNames(`${panelclass || ''}`, {
          'ui-block': expanded,
          'ui-hidden': !expanded,
        })}
      >
        {panel}
      </div>
    </>
  );
};
